import { Link } from 'react-router-dom'
import React from 'react'
import haus_img from './images/haus.jpg'
import zug_img from './images/zug.jpg'
import logo from './images/upper-austria-logo-de.png'

class Startpage extends React.Component {
	render() {
		return (
				<div>
				<nav className="navbar navbar-default">
				  <div className="container-fluid header">
				    <div className="navbar-header">
				    <div className="row">
				    <div className="col-xs-12"><a href="https://www.upperaustria.at/de" target="_blank" rel="noopener noreferrer"><img alt="Land Oberösterreich Logo" className="img-responsive img-circle landooe-logo-header" src={logo}></img></a></div>
				    </div>
				  </div>
				  </div>
				</nav>
			    <div className="container-fluid">
			    <div className="page-header">
				  <h1>Herzlich Willkommen beim "Mobilitätsrechner Oberösterreich"</h1>
				  <p className="help-block">Auf den folgenden Seiten können Sie Umfeldqualität und die Kosten eines Wohnstandortes
				  hinsichtlich Wohnen und Mobilität in Oberösterreich berechnen und Wohnstandorte miteinander vergleichen.</p>
				</div>
				<div className="panel panel-default">
				  <div className="panel-body">
				  	<a className="pull-right" href="/static/pdf/moreOOE_hilfe.pdf" target="_blank">Hilfe (PDF)</a>
				  	<span className="help-block">Wo möchten Sie wohnen? Wählen sie einen Standort...</span>
				    <div className="btn-group" role="group" aria-label="...">
				    <Link to={{pathname: '/wohnstandorte/1/addressmap' }}><button type="button" className="btn btn-default">Wohnstandort auswählen</button></Link>
				    </div>
				 <hr></hr>
				<div className="row">
				  <div className="col-xs-6 col-md-4"><img className="img-responsive img-circle" src={zug_img} alt="Durchfahrender Zug"></img></div>
				  <div className="col-xs-12 col-md-8">
				  <h3>Infrastruktur und Öffentlicher Verkehr</h3>
				  Die Umfeldqualität eines Wohnstandorts hat maßgeblichen Einfluss auf die ökologische, soziale und ökonomische Nachhaltigkeit von Wohnstandorten.
				  Bedingt durch die fußläufige Erreichbarkeit von infrastrukturellen
				  Einrichtungen können Energieverbrauch und Emissionen gesenkt werden (der Verkehr macht etwa ein Drittel der
				  jährlichen österreichischen Gesamtmenge an klimarelevanten Emissionen aus). Bewohner können aber auch durch aktive Bewegung mit Fuß und Rad direkt Kosten sparen.</div>
				</div>
				<hr></hr>
				<div className="row">
				  <div className="col-xs-6 col-md-4"><img className="img-responsive img-circle" src={haus_img} alt="Gebäude mit Berg im Hintergrund"></img></div>

				  <div className="col-xs-12 col-md-8">
				  <h3>Wohn- und Mobilitätskosten</h3>
				  Aufwand und Kosten für die Mobilität können in Summe beträchtlich sein. Mobilitätskosten umfassen
				  nicht nur Treibstoffkosten: Anschaffung bzw. Wertverlust jedes Fahrzeugs, Wartung, Steuern und
				  Parken etc. übersteigen die Treibstoffkosten meistens deutlich. Je nach Wohnstandort bieten sich
				  kostengünstigere Alternativen wie Fußweg, Fahrrad, E-Bikes und der öffentliche Verkehr. Unter
				  Umständen ist eine etwas teurere Wohnung oder ein teurerer Bauplatz an einem Standort mit diesen
				  Alternativen in Summe sogar günstiger, weil Sie dadurch auf lange Sicht Mobilitätskosten einsparen.
				  Es zahlt sich somit aus, Wohnstandorte zu vergleichen. Betrachten Sie Mobilitätskosten und
				  Wohnkosten gemeinsam!
				  </div>
				</div>
				 </div>
				 </div>
				 <p className="small">Entwickelt von <a href="https://ispace.researchstudio.at/" target="_blank" rel="noopener noreferrer">RSA Studio iSPACE</a>. Basierend auf <a href="http://www.moreco.at" target="_blank" rel="noopener noreferrer">moreco.at</a> | <a href="/impressum" target="_blank" rel="noopener noreferrer">Impressum & Datenschutz & Barrierefreiheit</a></p>
				 </div>
				 </div>
			);
	}
}

export default Startpage





// WEBPACK FOOTER //
// ./src/Startpage.js